import { Modal } from "~/jose_modern/modal";
import { onViewLoad } from "~/jose_modern/on_view_load.js";

onViewLoad(
  [
    /^recipes#(edit|history|breakdown|recipe_card|cost)$/,
    "ingredient_metas#index_for_recipe",
    "ingredient_allergens#index_for_recipe",
  ],
  () => {
    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-recipe-lock-trigger]");
      if (!trigger) return;

      event.preventDefault();
      trigger._tippy?.hide();
      Modal.show("#recipe-lock-modal");
    });
  }
);
